import * as React from 'react';

// Style
import './Container.css';

// Component
export interface IProps {
  size: 'sm' | 'md' | 'lg' | 'xl';
  fluid?: boolean;
  padded?: boolean;
  verticalPadded?: boolean;
  horizontalPadded?: boolean;

  className?: string;
  style?: React.CSSProperties;
  children?:
    | JSX.Element
    | string
    | number
    | Array<JSX.Element | string | number>;
}

function Container(props: IProps) {
  const classes = ['Container', `Container--${props.size}`];

  if (props.fluid === true) {
    classes.push('Container--fluid');
  }
  if (props.padded === true) {
    classes.push('Container--padded');
  }
  if (props.verticalPadded === true) {
    classes.push('Container--padded-vertical');
  }
  if (props.horizontalPadded === true) {
    classes.push('Container--padded-horizontal');
  }
  if (props.className) {
    classes.push(props.className);
  }
  return (
    <div className={classes.join(' ')} style={props.style}>
      {props.children}
    </div>
  );
}

export default Container;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Container/Container.tsx